import * as React from "react";
import { Search } from "lucide-react";

import { cn } from "../../lib/utils.js";
import { Input, type InputProps } from "./input.js";

// The search box used above lists and tables: an Input with a leading search
// icon. Width goes on `className` (e.g. "w-72"); everything else is Input's.
export interface SearchInputProps extends Omit<InputProps, "type"> {}

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(({ className, ...props }, ref) => (
  <div className={cn("relative w-64", className)}>
    <Search
      size={14}
      aria-hidden="true"
      className="pointer-events-none absolute top-1/2 left-2.5 -translate-y-1/2 text-surface-400"
    />
    <Input ref={ref} className="w-full pl-8" {...props} />
  </div>
));
SearchInput.displayName = "SearchInput";

export { SearchInput };
